"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PixelmonBridgeWrapper;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function PixelmonBridgeWrapper(_ref) {
  var pixelmonInstance = _ref.pixelmonInstance,
    children = _ref.children,
    projectId = _ref.projectId,
    appId = _ref.appId,
    weSdkVersion = _ref.weSdkVersion;
  var _useState = (0, _react.useState)(pixelmonInstance._sessionHistory.firedPixels),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firedPixels = _useState2[0],
    setFiredPixels = _useState2[1];
  (0, _react.useEffect)(function () {
    var onPixel = function onPixel() {
      setFiredPixels((0, _toConsumableArray2["default"])(pixelmonInstance._sessionHistory.firedPixels));
    };
    pixelmonInstance.on('pixel', onPixel);
    return function () {
      pixelmonInstance.off('pixel', onPixel);
    };
  }, []);
  var _useState3 = (0, _react.useState)(pixelmonInstance._activePixelEvents),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    registeredPixels = _useState4[0],
    setRegisteredPixels = _useState4[1];
  (0, _react.useEffect)(function () {
    var onRegisterPixels = function onRegisterPixels() {
      setRegisteredPixels((0, _toConsumableArray2["default"])(pixelmonInstance._activePixelEvents));
    };
    pixelmonInstance.on('registerpixels', onRegisterPixels);
    return function () {
      pixelmonInstance.off('registerpixels', onRegisterPixels);
    };
  }, []);
  return /*#__PURE__*/_react["default"].cloneElement(children, {
    registeredPixels: registeredPixels,
    firedPixels: firedPixels,
    projectId: projectId,
    appId: appId,
    weSdkVersion: weSdkVersion
  });
}